"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const store_1 = require("store");
const react_1 = __importStar(require("react"));
const custom_cell_style_1 = __importDefault(require("./custom-cell.style"));
const kendo_react_grid_1 = require("@progress/kendo-react-grid");
function actionCell(arg) {
    const { appTheme } = (0, store_1.useAppSelector)((state) => state.app);
    return class ActionCellClass extends react_1.default.Component {
        render() {
            const { dataItem } = this.props;
            return ((0, jsx_runtime_1.jsx)("td", Object.assign({ className: this.props.className + ' k-command-cell', style: Object.assign(Object.assign({}, custom_cell_style_1.default.commandCell(appTheme, this.props.dataIndex)), this.props.style), colSpan: this.props.colSpan, role: 'gridcell', "aria-colindex": this.props.ariaColumnIndex, "aria-selected": this.props.isSelected }, { [kendo_react_grid_1.GRID_COL_INDEX_ATTRIBUTE]: this.props.columnIndex }, { children: arg.map((item, index) => item.permission ? ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [item.type === 'kendo' && ((0, jsx_runtime_1.jsx)("span", { className: item.iconClassName, style: custom_cell_style_1.default.icon(index + 1 < arg.length), onClick: () => item.onClick(dataItem) })), item.type === 'other' && ((0, jsx_runtime_1.jsx)("span", Object.assign({ style: custom_cell_style_1.default.icon(index + 1 < arg.length), onClick: () => item.onClick(dataItem) }, { children: item.icon })))] }, index)) : ('')) })));
        }
    };
}
exports.default = actionCell;
